import React from 'react'

const Transfer = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="11" viewBox="0 0 20 16">
    <path d="M15,12l5-4L15,4V7H2V9H15Zm7,3H9V12L4,16l5,4V17H22Z" transform="translate(-2 -4)" fill="#fff"/>
  </svg>
)

export default Transfer
